export default {
    /**
     * 默认图片域名
     */
    defaultPicDomain: 'https://img.dmallcdn.com/'
}